/**
 * Подписи типов действий и сущностей для лога активности (classic ActivityLog.js).
 */

const ACTIVITY_TYPE_LABELS: Record<string, string> = {
  ticket_created: 'Создан тикет',
  ticket_updated: 'Обновлен тикет',
  ticket_deleted: 'Удалён тикет',
  ticket_opened: 'Открыт тикет',
  ticket_closed: 'Закрыт тикет',
  ticket_resolved: 'Завершён тикет',
  ticket_status_changed: 'Статус изменён',
  ticket_priority_changed: 'Приоритет изменён',
  ticket_assigned: 'Назначен тикет',
  ticket_unassigned: 'Снято назначение',
  spam_sender_blocked: 'Отправитель заблокирован',
  spam_sender_unblocked: 'Отправитель разблокирован',
  spam_ai_paused: 'Защита от спама: пауза Мозгобота',
  message_created: 'Сообщение',
  message_updated: 'Изменено сообщение',
  message_deleted: 'Удалено сообщение',
  label_added: 'Добавлена метка',
  label_removed: 'Удалена метка',
  shift_started: 'Начал смену',
  shift_ended: 'Завершил смену',
  shift_ended_inactivity: 'Смена завершена по бездействию',
  shift_ended_break_limit: 'Автозавершение смены по перерыву',
  break_started: 'Начал перерыв',
  break_ended: 'Завершил перерыв',
  break_ended_auto: 'Автозавершение перерыва',
  project_created: 'Создан проект',
  project_updated: 'Обновлен проект',
  project_deleted: 'Удалён проект',
  user_login: 'Вход',
  user_logout: 'Выход',
  filter_created: 'Создан фильтр',
  filter_updated: 'Обновлен фильтр',
  filter_deleted: 'Удалён фильтр',
  conveyor_started: 'Конвейер запущен',
  conveyor_ticket_skipped: 'Тикет пропущен',
  conveyor_ticket_completed: 'Тикет завершён',
  review_requested: 'Запрос отзыва',
  user_identifier_added: 'Данные пользователя добавлены',
  user_identifier_updated: 'Данные пользователя изменены',
  user_identifier_removed: 'Данные пользователя удалены',
  customer_data_added: 'Данные клиента добавлены',
  customer_data_updated: 'Данные клиента изменены',
  ticket_redistributed: 'Тикет перераспределён',
  ticket_redistribution_revoked: 'Тикет вышел из перераспределения',
  ticket_help_requested: 'Отправлен запрос помощи',
  tickets_bulk_update: 'Массовая смена статуса',
  tickets_bulk_reply: 'Массовая рассылка сообщений',
  role_permissions_updated: 'Изменены права роли',
  ticket_handle_timeout: 'Превышено время обработки тикета',
  ai_auto_resolve_blocked: 'Автозавершение ИИ заблокировано',
}

const ENTITY_TYPE_LABELS: Record<string, string> = {
  ticket: 'Тикет',
  message: 'Сообщение',
  project: 'Проект',
  user: 'Пользователь',
  label: 'Метка',
  shift: 'Смена',
  filter: 'Фильтр',
  user_identifier: 'Данные пользователя',
}

export function formatActivityLogActionType(type: string): string {
  return ACTIVITY_TYPE_LABELS[type] || type
}

export function formatActivityLogEntityType(type: string | null | undefined): string {
  if (!type) return '—'
  return ENTITY_TYPE_LABELS[type] || type
}

/** Цвет бейджа Mantine по эвристике classic getActivityColor */
export function activityLogActionBadgeColor(activityType: string): string {
  const t = activityType || ''
  if (t === 'shift_ended_inactivity') return 'orange'
  if (t === 'shift_ended_break_limit' || t === 'break_ended_auto') return 'orange'
  if (t.includes('created') || t.includes('added') || t.includes('resolved') || t.includes('completed'))
    return 'green'
  if (t.includes('deleted') || t.includes('removed')) return 'red'
  if (t.includes('updated') || t.includes('changed')) return 'yellow'
  return 'blue'
}
